import { createContext, useContext, useState } from 'react';
const HighlightContext = createContext({
  highlightedText: '',
  setHighlightedText: () => undefined
});

// Context used for data shared across all tables
export const useHighlightMeta = () => {
  const context = useContext(HighlightContext);
  if (context === null) {
    throw new Error('Could not get highlight context. Did you forget to use HighlightMetaProvider?');
  }
  return context;
};

/** Same as {@link useHighlightMeta}, but will never throw errors. */
export const useHighlightMetaSafe = () => {
  return useContext(HighlightContext);
};
export function HighlightMetaProvider({
  children
}) {
  const [highlightedText, setHighlightedText] = useState('');
  const value = {
    highlightedText,
    setHighlightedText
  };
  return <HighlightContext.Provider value={value}>
			{children}
		</HighlightContext.Provider>;
}